// Third-party / browser noise that is not actionable from our code. Shared by
// the PostHog before_send filter and Sentry's ignoreErrors.
// - "Java object is gone": Facebook/Instagram Android in-app browser bridge.
// - ResizeObserver loop warnings: benign browser notifications.
export const IGNORED_ERROR_PATTERNS: RegExp[] = [
  /Error invoking postMessage: Java object is gone/i,
  /ResizeObserver loop completed with undelivered notifications/i,
  /ResizeObserver loop limit exceeded/i,
];

export function isIgnoredErrorMessage(message: unknown): boolean {
  return typeof message === 'string' && IGNORED_ERROR_PATTERNS.some(re => re.test(message));
}
